module.exports = __webpack_public_path__ + "img/amazon.bbf90f21.png";